<div class="dashboard-container">
  @if (isLoading()) {
    <div class="text-center py-5">
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-3">Loading dashboard...</p>
    </div>
  } @else {
    <!-- Quick Stats -->
    <div class="row g-3 mb-4">
      @if (stats(); as dashboardStats) {
        <!-- Reports This Month -->
        <div class="col-lg-3 col-md-6">
          <app-metric-card
            [currentValue]="dashboardStats.reports_this_month"
            [title]="'Reports This Month'"
            [hideComparison]="true"
            [hidePrevious]="true"
            [showLeftBorder]="true"
            [leftBorderColor]="'var(--bootstrap-primary)'"
          ></app-metric-card>
        </div>

        <!-- Scheduled Reports -->
        <div class="col-lg-3 col-md-6">
          <app-metric-card
            [currentValue]="dashboardStats.scheduled_reports"
            [title]="'Scheduled Reports'"
            [hideComparison]="true"
            [hidePrevious]="true"
            [showLeftBorder]="true"
            [leftBorderColor]="'var(--bootstrap-success)'"
          ></app-metric-card>
        </div>

        <!-- Active Customers -->
        <div class="col-lg-3 col-md-6">
          <app-metric-card
            [currentValue]="dashboardStats.active_customers"
            [title]="'Active Customers'"
            [hideComparison]="true"
            [hidePrevious]="true"
            [showLeftBorder]="true"
            [leftBorderColor]="'var(--bootstrap-info)'"
          ></app-metric-card>
        </div>

        <!-- Failed Reports -->
        <div class="col-lg-3 col-md-6">
          <app-metric-card
            [currentValue]="dashboardStats.failed_reports"
            [title]="'Failed Reports'"
            [hideComparison]="true"
            [hidePrevious]="true"
            [showLeftBorder]="true"
            [leftBorderColor]="'var(--bootstrap-danger)'"
          ></app-metric-card>
        </div>
      }
    </div>

    <!-- Recent Reports -->
    <div class="card mb-4">
      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Recent Reports (Last 30 Days)</h5>
        <a
          href="#"
          class="text-primary text-decoration-none"
        >
          View All →
        </a>
      </div>
      <div class="card-body p-0">
        @if (recentReports().length === 0) {
          <div class="text-center py-5">
            <p class="text-muted mb-0">No recent reports</p>
          </div>
        } @else {
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>Status</th>
                  <th>Report Type</th>
                  <th>Customers</th>
                  <th>Generated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (report of recentReports(); track report.id) {
                  <tr>
                    <td>
                      <span [class]="getStatusClass(report.status)">
                        {{ getStatusIcon(report.status) }} {{ report.status }}
                      </span>
                    </td>
                    <td>
                      <strong>{{ report.report_type_name }}</strong>
                    </td>
                    <td>
                      <span class="text-muted">{{ report.customer_names[0] }}</span>
                    </td>
                    <td>
                      <span class="text-muted">{{ formatDate(report.created_at) }}</span>
                    </td>
                    <td>
                      @if (report.status === 'completed') {
                        <button
                          class="btn btn-sm btn-link text-primary"
                          (click)="downloadReport(report)"
                        >
                          Download
                        </button>
                      }
                      @if (report.status === 'failed') {
                        <button
                          class="btn btn-sm btn-link text-danger"
                          (click)="retryReport(report)"
                        >
                          Retry
                        </button>
                      }
                      @if (report.status === 'processing') {
                        <span class="text-muted">Processing...</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>

    <!-- Upcoming Scheduled Reports -->
    <div class="card">
      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Upcoming Scheduled Reports</h5>
        <a
          href="#"
          class="text-primary text-decoration-none"
        >
          Manage Schedules →
        </a>
      </div>
      <div class="card-body p-0">
        @if (upcomingSchedules().length === 0) {
          <div class="text-center py-5">
            <p class="text-muted mb-0">No upcoming scheduled reports</p>
          </div>
        } @else {
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>Report Type</th>
                  <th>Customers</th>
                  <th>Frequency</th>
                  <th>Next Run</th>
                </tr>
              </thead>
              <tbody>
                @for (schedule of upcomingSchedules(); track schedule.id) {
                  <tr>
                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <span class="schedule-icon">⏰</span>
                        <strong>{{ schedule.report_type_name }}</strong>
                      </div>
                    </td>
                    <td>
                      <span class="text-muted">{{ schedule.customer_names[0] }}</span>
                    </td>
                    <td>
                      <span class="badge bg-light text-dark">{{ schedule.frequency }}</span>
                    </td>
                    <td>
                      <span class="text-muted">{{ formatDate(schedule.next_run) }}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  }
</div>
